/**
 * Whether a socket `newMessage` is a re-emit of a message the client already
 * knows about — either from loaded history or from the server-hydrated
 * channel sidebar (`lastMessage_id`) when history has not been fetched yet.
 */
export const isAlreadyKnownMessage = ({ messageId, messageIds = [], lastMessageId }) => {
  if (!messageId) {
    return false;
  }
  if (messageIds.includes(messageId)) {
    return true;
  }
  return Boolean(lastMessageId && lastMessageId === messageId);
};
